<div class="d-flex align-items-center flex-column py-5" *ngIf="switch" style="z-index: 100009; position: fixed; width: 100%; height: 100%; top: 0px; left: 0px; background: #000000; filter: alpha(opacity =  60); -moz-opacity: 0.6; opacity: 0.6;">
    <div align="center"> <img src="../../assets/img/loading.gif" alt="image04" style="margin-top: 22%" />
      <span class="sr-only">Loading...</span>
    </div>
    <p class="mt-1 w700">
      Cargando...
    </p>
  </div>
<!-- <div class="d-flex align-items-center flex-column py-5" *ngIf="switch">
  <div class="spinner-grow text-primary" role="status" style="width: 5rem; height: 5rem;">
    <span class="sr-only">Loading...</span>
  </div>
  <p class="mt-1 w700">
    Cargando...
  </p>
</div> -->
